module.exports = __webpack_public_path__ + "img/1728607626941-Screenshot_11-10-2024_84653_www.instagram.com.jpeg.b9576c85.webp";